// Module
var code = "<div class=\"\"> <div class=\"container-xxl ps-0\"> <div class=\"row\"> <div class=\"col-md-12\"> <div data-display=\"grid\" id=\"{{id}}-landing-search-box\" class=\"search-bar-wrap landing-search-box\" name=\"search-name\"></div> </div> </div> </div> </div>";
// Exports
export default code;